import { t } from "@/i18n-js/instance";
import valuePropEn1x from "@circle-assets/images/features/profile-fields/en/value-prop_1x.png";
import valuePropEn2x from "@circle-assets/images/features/profile-fields/en/value-prop_2x.png";
import { PlanTrialCard } from "./PlanTrialCard";
import { I18N_LOCALE_ROOT } from "./constants";

interface RightPaneProps {
  isPlanLoading?: boolean;
  plan?: {
    display_base_monthly_amount?: string;
    display_name?: string;
  };
}

export const RightPane = ({ plan, isPlanLoading }: RightPaneProps) => {
  const srcSet = `${valuePropEn1x} 1x, ${valuePropEn2x} 2x`;

  return (
    <div className="hidden flex-col lg:flex">
      <img
        src={valuePropEn1x}
        srcSet={srcSet}
        alt={t(`${I18N_LOCALE_ROOT}.image_alt`)}
        loading="eager"
        className="size-full rounded-tr-lg object-cover"
      />
      <PlanTrialCard
        plan={plan}
        isPlanLoading={isPlanLoading}
        className="rounded-t-none"
      />
    </div>
  );
};
